import './about.css';
import { Link } from 'react-router-dom';
const About =()=>{
    return(
<div className="About">
<br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
<br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
        <center>
          <img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669015111/logo_2_vqa5nf.png" width={200} height={180} />
        </center>
        <ul>
        <li><Link to="/"><b>HOME</b></Link></li>
        <li><Link to="/about"><b>ABOUT US</b></Link></li>
        <li><Link to="/menu"><b>MENU</b></Link></li>
        <li><Link to="/offers"><b>OFFERS</b></Link></li>

        </ul>
        <div className id="about">
          <div className="content">
            <center><h1 className="z" style={{marginBottom: '64px',alignContent:'center'}}>ABOUT US</h1>
            <img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669015111/logo_2_vqa5nf.png" alt="logo" width="15%"/></center>
            <p className="keer">Every day, more than 11 million guests visit OMG Burger restaurants around the world.
              And they do so because our restaurants are known for serving high-quality, great-tasting,
              and affordable food. Founded in 1954, OMG Burger is the second largest fast food hamburger
              chain in the world. The original Home of the Whopper, our commitment to premium ingredients,
              signature recipes, and family-friendly dining experiences is what has defined our brand for 
              more than 50 successful years</p>
            <center><img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669263974/11_vlkatk.png" style={{width: '150px'}} className="circle right" alt="Chef" /></center>
            <center><p><strong>The Chef?</strong> Mr. Italiano himself</p></center>
            <br /><center><h2>We are proud of our interiors.</h2></center>
            <img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669263941/12_m94qsk.jpg" style={{width: '100%'}} alt="Restaurant" />
            <center><h2><b>Opening Hours</b></h2></center>
            <div className>
              <div className>
                <center><p>Mon &amp; Tue CLOSED</p>
                  <p>Wednesday 10.00 - 24.00</p>
                  <p>Thursday 10:00 - 24:00</p></center>
              </div>
              <center><div className>
                  <p>Friday 10:00 - 12:00</p>
                  <p>Saturday 10:00 - 23:00</p>
                  <p>Sunday Closed</p></div></center>
              <center><h2 className="pillai">CONTACT</h2>
                <h3>OMG Burger Corporation</h3>
                <h4>Phone Number: 1-866-394-2493</h4></center>
            </div>
          </div>
        </div>
        <div className="contact-info">
          <div className="card">
            <i className="card-icon far fa-envelope" />
            <p>omgB@email.com</p>
          </div>
          <div className="card">
            <i className="card-icon fas fa-phone" />
            <p>+91 9876543210</p>
          </div>
          <div className="card">
            <i className="card-icon fas fa-map-marker-alt" />
            <p>SKCET, Coimbatore</p>
          </div>
        </div>
      </div>
    )
};
export default About;